import { z } from "zod";

import { eventSchema } from "../shared";

// Billing Portal Events
export const billingPortalAccessedEvent = eventSchema.extend({
  event: z.string().default("billing_portal_accessed"),
  properties: z.object({
    userEmail: z.string(),
  }),
});

export const pricingTableViewedEvent = eventSchema.extend({
  event: z.string().default("pricing_table_viewed"),
  properties: z.object({
    userEmail: z.string(),
    userId: z.string(),
  }),
});

// Subscription Events
export const subscriptionCreatedEvent = eventSchema.extend({
  event: z.string().default("subscription_created"),
  properties: z.object({
    userEmail: z.string(),
    customerId: z.string(),
    subscriptionId: z.string(),
    status: z.string(),
  }),
});

export const subscriptionUpdatedEvent = eventSchema.extend({
  event: z.string().default("subscription_updated"),
  properties: z.object({
    userEmail: z.string(),
    customerId: z.string(),
    subscriptionId: z.string(),
    status: z.string(),
    previousStatus: z.string().optional(),
  }),
});

export const subscriptionCancelledEvent = eventSchema.extend({
  event: z.string().default("subscription_cancelled"),
  properties: z.object({
    userEmail: z.string(),
    customerId: z.string(),
    subscriptionId: z.string(),
  }),
});

export const plusStatusUpdatedEvent = eventSchema.extend({
  event: z.string().default("plus_status_updated"),
  properties: z.object({
    userEmail: z.string(),
    isActive: z.boolean(),
    reason: z.enum(["subscription_created", "subscription_updated", "subscription_cancelled"]),
  }),
});

// Webhook Events
export const webhookProcessedEvent = eventSchema.extend({
  event: z.string().default("webhook_processed"),
  properties: z.object({
    eventType: z.string(),
    success: z.boolean(),
    errorMessage: z.string().optional(),
  }),
});

// Type exports
export type BillingPortalAccessedEvent = z.infer<typeof billingPortalAccessedEvent>;
export type PricingTableViewedEvent = z.infer<typeof pricingTableViewedEvent>;
export type SubscriptionCreatedEvent = z.infer<typeof subscriptionCreatedEvent>;
export type SubscriptionUpdatedEvent = z.infer<typeof subscriptionUpdatedEvent>;
export type SubscriptionCancelledEvent = z.infer<typeof subscriptionCancelledEvent>;
export type PlusStatusUpdatedEvent = z.infer<typeof plusStatusUpdatedEvent>;
export type WebhookProcessedEvent = z.infer<typeof webhookProcessedEvent>;
